import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "failure grid grid-cols-4 border-b items-center"
}
const _hoisted_2 = { class: "title gordita-400-12 text-Text/text_medium py-3" }
const _hoisted_3 = { class: "value gordita-400-12 text-Text/text_high pl-1" }
const _hoisted_4 = { class: "errors_warnings grid grid-cols-2 grid-flow-col justify-stretch" }
const _hoisted_5 = { class: "build flex gap-3" }
const _hoisted_6 = { class: "build_title gordita-400-12 text-Text/text_medium w-full" }
const _hoisted_7 = { class: "grid grid-flow-col w-full justify-stretch" }
const _hoisted_8 = { class: "ib flex gap-3 pl-4 border-l border-System/app_border" }
const _hoisted_9 = { class: "build_title gordita-400-12 text-Text/text_medium w-full" }
const _hoisted_10 = { class: "grid grid-flow-col w-full justify-stretch" }


import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import WorkloadViewSummaryErrorItem from './workload-view-summary-error-item.vue';

type Props = {
  failureReason?: string;
  buildErrors: number;
  buildWarnings: number;
  ibErrors: number;
  ibWarnings: number;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'workload-view-summary-errors',
  props: {
    failureReason: null,
    buildErrors: null,
    buildWarnings: null,
    ibErrors: null,
    ibWarnings: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "workload-view-summary-errors flex flex-col gap-4" }, {
    default: _withCtx(() => [
      (__props.failureReason)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('workloads.details.summaryTab.errors.failureReason')), 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString(__props.failureReason), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('workloads.details.summaryTab.errors.buildSystem')), 1),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(WorkloadViewSummaryErrorItem, {
              "data-testid": "build-errors",
              "icon-class": "bg-red-400",
              title: _ctx.$t('workloads.details.summaryTab.errors.errors'),
              total: __props.buildErrors
            }, null, 8, ["title", "total"]),
            _createVNode(WorkloadViewSummaryErrorItem, {
              "data-testid": "build-warnings",
              "icon-class": "bg-System/app_warning",
              class: "border-l pl-4 border-System/app_border",
              title: _ctx.$t('workloads.details.summaryTab.errors.warnings'),
              total: __props.buildWarnings
            }, null, 8, ["title", "total"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('workloads.details.summaryTab.errors.ibSystem')), 1),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(WorkloadViewSummaryErrorItem, {
              "data-testid": "ib-errors",
              title: _ctx.$t('workloads.details.summaryTab.errors.errors'),
              "icon-class": "bg-red-400",
              total: __props.ibErrors,
              "value-class": "gordita-500-12"
            }, null, 8, ["title", "total"]),
            _createVNode(WorkloadViewSummaryErrorItem, {
              "data-testid": "ib-warnings",
              "icon-class": "bg-System/app_warning",
              class: "border-l pl-4 border-System/app_border",
              title: _ctx.$t('workloads.details.summaryTab.errors.warnings'),
              total: __props.ibWarnings,
              "value-class": "gordita-500-12"
            }, null, 8, ["title", "total"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})